module.exports = __webpack_public_path__ + "static/media/03fa-standard.3ed1989e.png";